import React, { createContext, useCallback, useContext, useState } from 'react';
import { ModalBodyVariant } from "./ModalBodyVariant";
import { jsx as ___EmotionJSX } from "@emotion/react";
var ModalLayoutContext = /*#__PURE__*/createContext({
  body: null,
  bodyVariant: ModalBodyVariant.Default,
  header: null,
  primaryButton: null,
  secondaryButton: null,
  setLayout: () => {}
});
export var ModalLayoutProvider = _ref => {
  var {
    children
  } = _ref;
  var [body, setBody] = useState(null);
  var [bodyVariant, setBodyVariant] = useState(ModalBodyVariant.Default);
  var [header, setHeader] = useState(null);
  var [primaryButton, setPrimaryButton] = useState(null);
  var [secondaryButton, setSecondaryButton] = useState(null);
  var setLayout = useCallback(_ref2 => {
    var {
      body,
      bodyVariant,
      header,
      primaryButton,
      secondaryButton
    } = _ref2;
    if (body !== undefined) {
      setBody(body);
    }
    if (bodyVariant !== undefined) {
      setBodyVariant(bodyVariant);
    }
    if (header !== undefined) {
      setHeader(header);
    }
    if (primaryButton !== undefined) {
      setPrimaryButton(primaryButton);
    }
    if (secondaryButton !== undefined) {
      setSecondaryButton(secondaryButton);
    }
  }, []);
  return ___EmotionJSX(ModalLayoutContext.Provider, {
    value: {
      body,
      bodyVariant,
      header,
      primaryButton,
      secondaryButton,
      setLayout
    }
  }, children({
    body,
    bodyVariant,
    header,
    primaryButton,
    secondaryButton
  }));
};
export function useModalLayout() {
  var context = useContext(ModalLayoutContext);
  return context;
}